import { render, staticRenderFns } from "./pnl.vue?vue&type=template&id=4a983b65&scoped=true"
import script from "./pnl.vue?vue&type=script&lang=js"
export * from "./pnl.vue?vue&type=script&lang=js"
import style0 from "./pnl.vue?vue&type=style&index=0&id=4a983b65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a983b65",
  null
  
)

export default component.exports